import * as v from "valibot";

// The pattern the previous validator used, kept so the same addresses are
// accepted. Valibot's built-in `email()` differs on apostrophes and on a
// hyphen at the end of a domain label.
const EMAIL_PATTERN = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;
export const emailSchema = v.object({
  email: v.pipe(v.string(), v.regex(EMAIL_PATTERN, "Ange en giltig e-postadress")),
  password: v.pipe(v.string(), v.minLength(1, "Ange ditt lösenord"))
});